import { CSSObject } from "@emotion/react";

export const rootCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
